import { gsap } from 'gsap'

const ARMS_READY_PATH = 'M87.7 61.4L102.28 50.7L116.86 61.4'
const ARMS_STRAIGHT_PATH = 'M 102 62 L 102.28 50.7 L 102 62 M 102.28 50.7'
const ARMS_EDGE_PATH = 'M102.28 54.5L102.28 66.8L102.28 79.1'

export function animateVistatLogo(root, options = {}) {
  if (!root) return null

  const scope = typeof root === 'string' ? document.querySelector(root) : root
  if (!scope) return null

  const marker = scope.querySelector('.vistat-logo__marker')
  const person = scope.querySelector('.vistat-logo__person')
  const torso = scope.querySelector('.vistat-logo__person-torso')
  const body = scope.querySelector('.vistat-logo__person-body')
  const arms = scope.querySelector('.vistat-logo__person-arms')
  const head = scope.querySelector('.vistat-logo__person-head')
  const repeat = options.repeat === undefined ? 0 : options.repeat
  const markerDelay = options.markerDelay === undefined ? 1.05 : options.markerDelay

  gsap.set([marker, person, torso, body, arms, head].filter(Boolean), {
    transformBox: 'fill-box',
    transformOrigin: '50% 50%'
  })
  gsap.set(torso, {
    rotationY: 0,
    transformPerspective: 320,
    transformOrigin: '50% 50%'
  })
  gsap.set(head, { y: -42, scale: 0.72, opacity: 0 })
  gsap.set(body, { scaleY: 0.35, opacity: 0, transformOrigin: '50% 100%' })
  gsap.set(arms, { attr: { d: ARMS_READY_PATH }, scaleX: 0.1, opacity: 0, transformOrigin: '50% 50%' })
  gsap.set(person, { x: -26, y: -10, rotate: -18, opacity: 0 })
  gsap.set(marker, { rotate: 0, y: 0, scale: 1 })

  return gsap.timeline({
    repeat,
    repeatDelay: options.repeatDelay === undefined ? 1.2 : options.repeatDelay,
    defaults: { ease: 'power3.out' }
  })
    .to(marker, {
      rotate: 360,
      y: 10,
      duration: 0.72,
      ease: 'power2.in'
    }, markerDelay)
    .to(marker, {
      y: -6,
      scaleX: 1.04,
      scaleY: 0.96,
      duration: 0.16,
      ease: 'power1.out'
    })
    .to(marker, {
      y: 0,
      scaleX: 1,
      scaleY: 1,
      duration: 0.34,
      ease: 'bounce.out'
    })
    .to(person, {
      x: 0,
      y: 0,
      rotate: 0,
      opacity: 1,
      duration: 0.5,
      ease: 'back.out(1.8)'
    }, '>-0.05')
    .to(body, {
      scaleY: 1,
      opacity: 1,
      duration: 0.26
    }, '<0.06')
    .to(arms, {
      scaleX: 1,
      opacity: 1,
      duration: 0.22
    }, '<0.12')
    .to(head, {
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 0.52,
      ease: 'bounce.out'
    }, '<0.18')
    .to(arms, {
      attr: { d: ARMS_STRAIGHT_PATH },
      duration: 2.16,
      ease: 'power2.out'
    }, '>-0.05')
    .to(torso, {
      rotationY: 84,
      duration: 0.24,
      ease: 'power2.in'
    }, '<0.02')
    // .to(arms, {
    //   scaleX: 0.08,
    //   duration: 0.2,
    //   ease: 'power2.in'
    // }, '<')
    // .set(arms, {
    //   attr: { d: ARMS_EDGE_PATH },
    //   scaleX: 1,
    //   opacity: 1
    // })
    .to(torso, {
      rotationY: 0,
      duration: 0.24,
      ease: 'back.out(1.4)'
    }, '>')
    .to(body, {
      scaleY: 1,
      scaleX: 1,
      opacity: 1,
      duration: 0.16
    }, '<')
}
